import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'
import { Action, Getter, State, Mutation } from 'vuex-class'
import BasicHeader from '@/components/trackerHeaderBasic/trackerHeaderBasic'
import BarChallengue from '@/components/trackerBarChallengue/trackerBarChallengue'
import NameCommerce from '@/components/trackerNameCommerce/trackerNameCommerce'
import ContentState from '@/components/trackerContentState/trackerContentState'
import ReclaimOrder from '@/components/trackerReclaimOrder/trackerReclaimOrder'

@Component({
  components: {
    BasicHeader,
    BarChallengue,
    NameCommerce,
    ContentState,
    ReclaimOrder
  },
  mounted() {
  }
})
export default class TrackerContentInfo extends Vue {
  @Getter getCurrentOrder: any
  @Getter getUser: any
  @Getter getOrderPayment: any;

  @State supportTracker: any
  @Action action_getCurrentOrder: any
  @Action action_getTransaction: any
  @Mutation SUPPORT_TRACKER: any

  textUpdateOrder = 'RECARGAR'

  _openChat() {
    // open_chat(`${this.getUser.first_name} ${this.getUser.last_name}`, this.getUser.email, this.getUser.cellphone, this.getUser.first_order_date, `Hola, tengo un problema con mi pedido con id ${this.getCurrentOrder.id}, necesito ayuda con mi método de pago, gracias`);
    // @ts-ignore
    // $crisp.push(["do", "chat:open"])
    // @ts-ignore
    // $crisp.push(["set", "message:text", [`Hola!. Estoy intentando hacer un pedido pero el cobro no fue efectuado me puedes ayudar. Orden #${this.getCurrentOrder.id}, Valor ${this.getCurrentOrder.total_currency}.`]])
  }

  async _updateOrder() {
    this.textUpdateOrder = 'ACTUALIZANDO'
    await this.action_getCurrentOrder(this.$route.params.order_id)
    this.textUpdateOrder = 'RECARGAR'
  }

  _goToPaymentLink() {
    if (this.getCurrentOrder.instance_currency === 'MXN') {
      location.href = `https://pay.conekta.com/link/${this.getCurrentOrder.payment_link}`;
    } else {
      location.href = `https://checkout.wompi.co/l/${this.getCurrentOrder.payment_link}`;
    }
  }

  async mounted() {
    await this.action_getTransaction(this.$route.params.order_id)
  }
}
